import { render } from "./DeveloperItemTag.vue?vue&type=template&id=d051174a"
import script from "./DeveloperItemTag.vue?vue&type=script&lang=js"
export * from "./DeveloperItemTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__